/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ManageEmailGroupsModel {
        private systemLevel: Wars.Domain.Model.SystemLevel;
        public emailGroups: Wars.Domain.Model.EmailGroup[];
        public newEmailGroup: Wars.Domain.Model.EmailGroup;
        public editEmailGroup: Wars.Domain.Model.EmailGroup;

        public isSystemEmailGroup: boolean;
        public addingNewEmailGroup: boolean;
        public showDeleteEmailGroupConfirm: boolean;
        public showDeleteExistingConfirm: boolean;

        constructor(
            private processConfigurationId: string,
            private emailGroupService: services.EmailGroupService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private modalService: any)
        {
            this.isSystemEmailGroup = !this.processConfigurationId;
            this.addingNewEmailGroup = false;
            this.showDeleteEmailGroupConfirm = false;
            this.showDeleteExistingConfirm = false;

            this.loadEmailGroups();
        }

        private loadEmailGroups() {
            if (this.isSystemEmailGroup) {
                this.systemLevelService.getSystemLevelEmailGroups()
                    .then((systemLevel) => {
                        this.systemLevel = systemLevel;
                        this.emailGroups = systemLevel.myEmailGroups;
                    });
            } else {
                this.emailGroupService.getAllProcessEmailGroups(this.processConfigurationId)
                    .then((emailGroups) => this.emailGroups = emailGroups);
            }
        }

        public addNewEmailGroup() : void {
            this.addingNewEmailGroup = true;
            this.newEmailGroup = this.emailGroupService.createNewEntity<Wars.Domain.Model.EmailGroup>("EmailGroup");
            this.addNewEmailAddressToGroup();
        }
        
        public addNewEmailAddressToGroup(): void {
            var newEmailAddress = this.emailGroupService.createNewEmailAddress();
            newEmailAddress.myEmailGroup = this.newEmailGroup;
            this.newEmailGroup.myEmailAddresses.push(newEmailAddress);
        }

        public deleteNewEmailAddress(index: number): void {
            this.newEmailGroup.myEmailAddresses.splice(index, 1);
        }

        private save(successCallback?: any): void {
            if (this.isSystemEmailGroup) {
                this.newEmailGroup.systemLevel_id = this.systemLevel.id;
            } else {
                this.newEmailGroup.processConfiguration_id = this.processConfigurationId;
            }
            this.emailGroupService.saveAllChanges(successCallback);
        }

        public saveNewEmailGroup(): void {
            this.save(() => this.saveSucceeded());
        }

        private saveSucceeded(): void {
            this.emailGroups.push(this.newEmailGroup);
            this.addingNewEmailGroup = false;
            this.newEmailGroup = undefined;
        }

        public cancelNewEmailGroup(): void {
            this.newEmailGroup = undefined;
            this.addingNewEmailGroup = false;
        }

        public deleteEmailGroup(): void {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "EmailGroup",
                this.editEmailGroup.id,
                "Successfully deleted Email Group",
                undefined,
                "Could not delete Email Group");
        }

        public editExistingEmailAddress(emailAddress: Wars.Domain.Model.EmailAddress): void {
            this.showModal(emailAddress);
        }

        public deleteExistingEmailAddress(emailAddress: Wars.Domain.Model.EmailAddress): void {
            emailAddress.entityAspect.setDeleted();
            this.save();
        }

        public addNewEmailAddressToEditGroup(): void {
            var newEmailAddress = this.emailGroupService.createNewEmailAddress();
            newEmailAddress.myEmailGroup = this.editEmailGroup;
            this.editEmailGroup.myEmailAddresses.push(newEmailAddress);

            this.editExistingEmailAddress(newEmailAddress);
        }

        private showModal(emailAddress: Wars.Domain.Model.EmailAddress) {
            this.modalService.showModal({
                templateUrl: "./app/views/modals/_emailAddressEditModal.html",
                controller: "editEmailAddressModalController",
                inputs: {
                    emailAddress: emailAddress
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        this.save();
                    } else {
                        this.emailGroupService.rejectChanges();
                    }
                });
            });
        }
    }
}